import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    $(this.element).tooltip({
      title: this.data.get("title")
    })
  }

  disconnect() {
    $(this.element).tooltip("dispose")
  }
}